import React from 'react';
import PropTypes from 'prop-types';

import './SquareBlock.css';

/**
 * Building block for Tetrominoes and the grid of the Well, occupying a 1x1
 * square block. The only configurable property square blocks have is their
 * color.
 */
const SquareBlock = ({ color }) => (
  <div className="square-block" style={{ backgroundColor: color }} />
);

SquareBlock.propTypes = {
  color: PropTypes.string.isRequired
};

export default SquareBlock;



// WEBPACK FOOTER //
// ./src/components/SquareBlock.jsx